import Vue from "vue"
import App from "./App.vue"
import Doggo from "@uarizona-fnsv/vue-doggo"
import "@uarizona-fnsv/bootstrap/dist/bootstrap.css"
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
import Swal from "sweetalert2"

import api from "./utils/api"
import router from "./router"
import vuetify from "./plugins/vuetify"

function getEnvironment() {
  const hostname = window.location.hostname
  if (hostname.includes("-dev")) return "dev"
  if (hostname.includes("cloudfront.net")) return "review"
  return "prod"
}

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: getEnvironment(),
  })
}

Vue.use(Doggo, {
  amplify: {
    region: process.env.VUE_APP_COGNITO_REGION,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    domain: process.env.VUE_APP_COGNITO_DOMAIN,
    redirectSignIn: process.env.VUE_APP_COGNITO_SIGN_IN_URL,
  },
  disable: process.env.VUE_APP_DISABLE_AUTH,
})

Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.prototype.$alert = Swal

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app")
